import { Component, OnInit } from '@angular/core';
import { TenantService } from '../../tenant/tenant.service';

@Component({
    selector: 'app-unsubscribe',
    templateUrl: './unsubscribe.component.html',
    styleUrls: ['./unsubscribe.component.scss'],
    standalone: false
})
export class UnsubscribeComponent implements OnInit {

  constructor(public tenantService: TenantService) { }

  ngOnInit(): void {
  }

}
